<template>
    <NuxtLayout name="default" mainClass="inside_main">
      <div class="container">
        <div class="search_section inside">
          <!-- Header Row with Title, Breadcrumb and Filter -->
          <div class="row align-items-center">
            <div class="col-6">
              <div class="section_title">
                <h1>
                  <span>
                    <!-- If a category exists, show its name.
                         Otherwise, if the is_recent flag is set (and no search term), show “أحدث التقييمات”;
                         else fallback to “نتائج البحث”. -->
                    {{ category ? category.name : (isRecent ? 'أحدث التقييمات' : 'نتائج البحث') }}
                  </span>
                </h1>
              </div>
              <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '\f10e';" class="breadcrumb_wrapper">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <NuxtLink to="/"><i class="fi-rr-home"></i> الرئيسية</NuxtLink>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    <a href="#" @click.prevent>
                      {{ category ? category.name : (isRecent ? 'أحدث التقييمات' : 'نتائج البحث') }}
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
            <div class="col-6">
              <div class="more">
                <div class="dropdown dropdown-filter-main">
                  <button class="section_subtitle dropdown-toggle"data-bs-toggle="modal"
                    data-bs-target="#filter_rate_modal"
                    aria-expanded="false">
                    <span>فلتر</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 22 20">
                        <g transform="translate(-1 -2)">
                        <path
                            d="M17,5a3,3,0,1,1,3,3,3,3,0,0,1-3-3ZM2,6H14a1,1,0,0,0,0-2H2A1,1,0,0,0,2,6ZM8,9a3,3,0,0,0-2.82,2H2a1,1,0,0,0,0,2H5.18A3,3,0,1,0,8,9Zm14,2H14a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2ZM10,18H2a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Zm12,0H18.82a3,3,0,1,0,0,2H22a1,1,0,0,0,0-2Z"
                            fill="#292d32"></path>
                        </g>
                    </svg>
                    </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Places List -->
          <div class="search_section_wrapper">
            <div class="row places_container" id="places_cont">

              <template v-if="Places.length > 0">

                <PlaceObject
                      v-for="place in Places"
                      :key="place.id"
                      :filterText="filterSearchInput"
                      :place_item="place"
                  />
                  
              </template>

              <template v-else-if="loading">
      
                <RateObjectPlaceholder v-for="n in 6" :key="n" :userShow="true" :placeShow="false" />
              </template>

              <div v-else class="col-md-12 text-center">
                <div class="item_empty">
                  <p>
                      لا توجد أماكن متاحة
                 </p>
                </div>
              </div>
              
            </div>
            <!-- Load More Button -->
            <div v-if="placesPage" class="moreLoading">
              <button class="section_subtitle place-load-more" @click="loadMore" :disabled="loading">
                <span v-if="!loading">عرض المزيد</span>
                <span v-else>تحميل...</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal bottomSheet userModels FilterRateModal" id="filter_rate_modal" tabindex="-1"
        aria-labelledby="filterModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header pb-0">

            </div>
            <!-- Modal Body -->
            <div class="modal-body pt-3">
              <form @submit.prevent="submitFilter">
                <div class="filter-rate-wrapper">
                  <div class="filter-head-title">
                    <h5 class="filter-title">فلترة التقييمات</h5>
                    <button @click="resetFilter" type="button" class="reset-filter">مسح الفلتر</button>
                  </div>
                  <div class="filter-body">
                    <div class="part">
                      <p class="filter_label">
                        ترتيب حسب
                      </p>
                      <div class="radio-input">
                        <label class="label">
                          <input type="radio" id="latest" v-model="filterOrder" name="value-radio" value="3">
                          <p class="text">الأحدث</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="highest" v-model="filterOrder" name="value-radio" value="1">
                          <p class="text">الأعلى</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="lowest" v-model="filterOrder" name="value-radio" value="4">
                          <p class="text">الأقل</p>
                        </label>

                        <label class="label">
                          <input type="radio" id="most-liked" v-model="filterOrder" name="value-radio" value="2">
                          <p class="text">الأكثر إعجاباً</p>
                        </label>
                      </div>
                    </div>
                    <div v-if="(category === null && !isRecent)" class="part">
                      <p class="filter_label">
                        تقييم يحتوي على كلمة
                      </p>

                      <div class="search_input">
                        <input class="searchInput" type="text" v-model="filterSearchInput" name="q" id="qM"
                          autocomplete="off" placeholder="بحث">
                        <button class="searchButton" type="button">
                          <svg id="vuesax_linear_search-normal" data-name="vuesax/linear/search-normal"
                            xmlns="http://www.w3.org/2000/svg" width="21.029" height="21.029"
                            viewBox="0 0 21.029 21.029">
                            <g id="search-normal">
                              <path id="Vector"
                                d="M16.648,8.324A8.324,8.324,0,1,1,8.324,0,8.324,8.324,0,0,1,16.648,8.324Z"
                                transform="translate(1.752 1.752)" fill="none" stroke="#d0d5dc" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.7" />
                              <path id="Vector-2" data-name="Vector" d="M1.752,1.752,0,0"
                                transform="translate(17.524 17.524)" fill="none" stroke="#d0d5dc" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.7" />
                              <path id="Vector-3" data-name="Vector" d="M0,0H21.029V21.029H0Z" fill="none"
                                opacity="0" />
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <button id="saveFilterButton" type="submit" class="filterSaveBtn has-spinner-link">
                      <div class="button_text">عرض</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <!-- End Modal Body -->
          </div>
        </div>
      </div>
    </NuxtLayout>
  </template>
  
  <script setup lang="ts">
  import { ref, onMounted, onUnmounted, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useHead } from '#imports'
  import Vue3StarRatings from '~/components/Vue3StarRatings.vue'
  import { categoriesRepository } from '~/utils/categoriesRepository'
  import type { Place, PlaceCategory } from '~/types/types'
  
  const { $api } = useNuxtApp()
  const route = useRoute()
  const categoryRepo = categoriesRepository($api)
  const placeRepo = placesRepository($api)
  
  // Reactive state
  const Places = ref<Place[]>([])
//   const category = ref<Category | null>(null)
  const filterOrder = ref<string | null>(null)

  const page = ref(1)
  const loading = ref(false)
  let placesPage = ref(1);
  
  // Get query parameters (for search term and recent flag)
  const q = ref(route.query.q ? String(route.query.q) : '')

  const filterSearchInput = q;

  const isRecent = ref(route.query.is_recent ? String(route.query.is_recent) !== 'no-recent' : false)
  
  // Utility: Slugify text (replace spaces with dashes and lowercase)
  const slugify = (text: string): string => text.replace(/\s+/g, '-').toLowerCase()
  
  // Generate URL similar to Laravel's route helper
  const generatePlaceUrl = (place: Place): string => {
    const slug = place.name ? slugify(place.name) : ''
    return `/place/${place.tenant}`
  }
  
  // Fetch places from repository; reset = true clears current list and resets page to 1
  const fetchPlaces = async (reset = false) => {
    loading.value = true
    try {
      if (reset) {
        placesPage.value = 1
        Places.value = []
      }
      // Assume the repository method accepts an ID and a filters object
       const {
            data: placesData,
            nextPage: placesNextPage
        } = await placeRepo.get({
                name: filterSearchInput.value ?? q.value,
                sort: filterOrder.value,
                from:'search_click',
                device_type:'3',
                isRecent: isRecent.value ? 'yes' : 'no-recent',
            },
            placesPage.value
        );
      // Assuming response has a structure like { data: Place[], lastPage: number }
      if (reset) {
        Places.value = placesData
      } else {
        Places.value.push(...placesData)
      }

      placesPage.value = placesNextPage;
    } catch (error) {
      console.error('Error fetching places:', error)
    } finally {
      loading.value = false
    }
  }
  
  // Fetch category details by ID
//   const fetchCategory = async () => {
//     try {
//       category.value = await categoryRepo.showById(route.params.id)
//     } catch (error) {
//       console.error('Error fetching category:', error)
//     }
//   }

const animateInView = () => {
  const scrolledAmount = window.scrollY;
  const bottomOfWindow = scrolledAmount + window.innerHeight;

  document.querySelectorAll('.item_rate').forEach((item) => {
    const cardTop = item.getBoundingClientRect().top + scrolledAmount;

    if (cardTop <= bottomOfWindow) {
      item.classList.add('animate');
      item.classList.remove('pre-animate');
    } else {
      item.classList.remove('animate');
      item.classList.add('pre-animate');
    }
  });
};



  
const {
          closeModal
      } = useBootstrapModal("filter_rate_modal");


      
/**
 * Handle the reset filter button.
 * Resets the filter to default values, clears the search input,
 * refreshes the reviews with default filter and closes the modal.
 */
const resetFilter = async () => {
  // Reset filter selections to default values (adjust as needed)
  filterOrder.value = null           // Reset to default value "latest"
  filterSearchInput.value = null      // Clear the search input

  // Reset the reviews list and load the default reviews.
  Places.value = []
  await fetchPlaces(true)

  // Optionally, you might want to close the modal here as well.
  closeModal()
}

/**
 * Handle form submission by setting the filter order.
 * The filtering logic could be extended to include search parameters
 * or additional business logic.
 */
const submitFilter = async (e: Event) => {

    loading.value = true;

    Places.value = [];

    await fetchPlaces(true)

    loading.value = false;
    
    closeModal()
}

  // Load next page of results
  const loadMore = async () => {
    if (loading.value) return
    await fetchPlaces()
  }
  
  onMounted(async () => {
    animateInView(); // Run on page load
    window.addEventListener('scroll', animateInView);
    // await fetchCategory()
    await fetchPlaces(true)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', animateInView);
  });
  
  // Update SEO meta tags based on category info

  useHead({
        title: 'نتائج البحث',
        meta: [
        { property: 'og:title', content: `نتائج البحث | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
        { property: 'twitter:title', content: `نتائج البحث | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },       
        ]
    })
  
  // React to changes in the query parameters (if the URL changes)
  watch(
    () => route.query,
    async () => {
      q.value = route.query.q ? String(route.query.q) : ''
      isRecent.value = route.query.is_recent ? String(route.query.is_recent) !== 'no-recent' : false
      await fetchPlaces(true)
    }
  )
  </script>
  
  <style scoped>
  .breadcrumb_wrapper {
    --bs-breadcrumb-divider: '\f10e';
  }
  .item_rate .item_content h3 {
    margin-bottom: 0.7rem;
  }
  .moreLoading {
    text-align: center;
    margin-top: 20px;
  }
  </style>
  